import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import "./Studentdownload.css";

const Studentdownload = () => {
  const topRef = useRef(null);

  const pdfList = [
    { id: 1, title: "Integrated MCA First Year Syllabus", src: "/Student_Downloads/Integrated MCA First Year Syllabus.pdf", isWeb: false },
    { id: 2, title: "No – Dues Certificate", src: "/Student_Downloads/No – Dues Certificate.pdf", isWeb: false },
    { id: 3, title: "MCA 2 Years – Syllabus A. Y. 2020", src: "/Student_Downloads/MCA 2 Years – Syllabus A. Y. 2020.pdf", isWeb: false },
    { id: 4, title: "MCA 3 Years – Syllabus A.Y. 2016 – 17 to A.Y. 2019 – 20 (CBCS)", src: "/Student_Downloads/MCA 3 Years – Syllabus A.Y. 2016 – 17 to A.Y. 2019 – 20 (CBCS).pdf", isWeb: false },
    { id: 5, title: "MCA 3 Years Syllabus A.Y. 2012-13 (CBSGS) – First Year", src: "/Student_Downloads/MCA 3 Years Syllabus A.Y. 2012-13 (CBSGS) – First Year.pdf", isWeb: false },
    { id: 6, title: "MCA 3 Years Syllabus A.Y. 2012-13 (CBSGS) – Second Year and Third Year", src: "/Student_Downloads/MCA 3 Years Syllabus A.Y. 2012-13 (CBSGS) – Second Year and Third Year.pdf", isWeb: false },
    { id: 7, title: "Application for Original documents", src: "/Student_Downloads/Application for Original documents.pdf", isWeb: false }
  ];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Student Downloads" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Student Downloads' }]} 
          />
        </div>

        <div className="spv-main-content">
          <aside className="spv-sidebar-modern">
            <div className="spv-sidebar-header-text">POLICY DOCUMENTS</div>
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area" key={activePdf.id}>            
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              
              {/* Added Download & Full Screen Icons */}
              <div className="spv-action-group">
                <a 
                  href={activePdf.src} 
                  download 
                  className="spv-icon-btn" 
                  title="Download PDF"
                >
                  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                  </svg>
                </a>
                <button 
                  className="spv-icon-btn" 
                  onClick={() => window.open(activePdf.src)} 
                  title="Full Screen"
                >
                  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"></path>
                  </svg>
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Document Viewer"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Studentdownload;